import React from "react";
import style from "./NoPage.module.css";

const NoPage = () => {
    return (
        <main className={style.pages} role="main" aria-labelledby="error-heading">
            <h1 id="error-heading">404 - Page not found</h1>
            <p>The page you are looking for doesn't exist or another error occurred.</p>
        </main>
    );
};

export default NoPage;
